module.exports = __webpack_public_path__ + "img/PD1505110802942787584.6ec46a08.png";